module.exports = __webpack_public_path__ + "static/11-26fb7fe1bd42f582ad9628ecd0f8b253.jpg";